import { useEventRegistrationStatus } from '@/hooks/useEvents';
import { RegistrationConfirmedDialog } from './RegistrationConfirmedDialog';

export interface MemberRegistrationConfirmedDialogProps {
  eventId: string;
  open: boolean;
  onClose: () => void;
}

/**
 * The registration pop-up for a signed-in member. Join details come from the
 * member's own registration status (FR-292), which registering refreshes.
 */
export function MemberRegistrationConfirmedDialog({
  eventId,
  open,
  onClose,
}: MemberRegistrationConfirmedDialogProps) {
  const { data } = useEventRegistrationStatus(eventId, open);
  return (
    <RegistrationConfirmedDialog
      open={open}
      onClose={onClose}
      locationType={data?.locationType}
      locationDetails={data?.isRegistered ? data.locationDetails : undefined}
    />
  );
}
